import type { TFunction } from 'i18next';

/** Internal field identifiers used in form state and API mapping. */
export const JOB_FIELD_I18N_KEYS: Record<string, string> = {
  'Job Title': 'job_title',
  Location: 'location',
  'Contract Type': 'contract_type',
  'Remote Policy': 'remote_policy',
  'Years of Experience': 'years_of_experience',
  'Required Degree': 'required_degree',
  'Role Description': 'role_description',
  'Mission Role in Job': 'role_description',
  'Company Name': 'company_name',
  'Company Sector': 'company_sector',
  'Company Description': 'company_description',
  Skills: 'skills',
};

export const SELECT_OPTION_VALUES: Record<string, readonly string[]> = {
  'Remote Policy': ['on_site', 'hybrid', 'full_remote'],
  'Contract Type': [
    'full_time',
    'part_time',
    'fixed_term',
    'contractor',
    'permanent',
    'internship',
  ],
  'Required Degree': [
    'Two-year degree',
    "Bachelor's",
    "Master's",
    'PhD',
    'None required',
  ],
};

const REQUIRED_DEGREE_VALUE_KEYS: Record<string, string> = {
  'Two-year degree': 'two_year_degree',
  "Bachelor's": 'bachelors',
  "Master's": 'masters',
  PhD: 'phd',
  'None required': 'none_required',
};

const OPTION_NAMESPACE: Record<string, string> = {
  'Remote Policy': 'remote_policy',
  'Contract Type': 'contract_type',
  'Required Degree': 'required_degree',
};

export function getJobFieldLabel(fieldName: string, t: TFunction<'dashboard'>): string {
  const key = JOB_FIELD_I18N_KEYS[fieldName];
  if (!key) return fieldName;
  return t(`create_job_modal.fields.${key}`, { defaultValue: fieldName });
}

export function getSelectOptionLabel(
  fieldName: string,
  value: string,
  t: TFunction<'dashboard'>
): string {
  const namespace = OPTION_NAMESPACE[fieldName];
  if (!namespace) return value;

  let optionKey = value;
  if (fieldName === 'Required Degree') {
    optionKey = REQUIRED_DEGREE_VALUE_KEYS[value] ?? value;
  }

  return t(`create_job_modal.options.${namespace}.${optionKey}`, { defaultValue: value });
}

export function getTranslatedSelectOptions(
  fieldName: string,
  t: TFunction<'dashboard'>
): { value: string; label: string }[] {
  const values = SELECT_OPTION_VALUES[fieldName] ?? [];
  return values.map((value) => ({
    value,
    label: getSelectOptionLabel(fieldName, value, t),
  }));
}
